import { ICellRendererParams } from "ag-grid-community";
import { ReactElement, useRef } from "react";
import { Box, Tooltip } from "@chakra-ui/react";
import { TemplateField } from "../../../api/types";
import { typedSxMap } from "../../../utils/typedSxMap";
import { PiInfo } from "react-icons/pi";


type IconKeyType = "error" | "warning" | "info";

const iconTypeMap: Record<IconKeyType, ReactElement> = {
  error: <PiInfo />,
  warning: <PiInfo />,
  info: <PiInfo />,
};

export const CELL_COLOR_MAP = {
  error: "var(--color-cell-background-error)",
  warning: "var(--color-cell-background-warning)",
  info: "var(--color-cell-background-error)",
};

const styles = typedSxMap({
  container: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    height: "calc(100% - 1px)",
    alignItems: "center",
    gap: "var(--m-xs)",
    "& > span": {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  },
  errors: {
    display: "flex",
  },
  tooltipWrapper: {
    position: "absolute",
    transform: "translateX(-50%)",
    backgroundColor: "var(--color-background-modal)",
    padding: "var(--m-xxs) var(--m-xs)",
    borderRadius: "var(--border-radius)",
    marginTop: "var(--m-xs)",
    boxShadow: "0 0 0 1px var(--color-border), 0 5px 15px rgba(0, 0, 0, 0.2)",
    maxWidth: "300px",
    zIndex: 1000,
    color: "var(--color-text)",
  },
});

const getIconType = (type: string): ReactElement => {
  return iconTypeMap[type as IconKeyType] || <PiInfo />;
};

export const cellRenderer = (params: ICellRendererParams, columnKey: string, theme: string, templateColumns: TemplateField[]) => {
  if (params.data) {
    const errors: any = params.data[columnKey]?.errors;
    const validation = templateColumns.find((column) => column.key === columnKey)?.validations.find((validation) => validation.id === errors?.[0]);
    const cellContent = (
      <Box sx={styles.container}>
        <span>{params?.data?.[columnKey]?.value} </span>
        {validation && (
          <Box sx={styles.errors}>
            <Tooltip sx={styles.tooltipWrapper} label={validation.message} aria-label={validation.message} arrowShadowColor="var(--color-border)">
              <span
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "var(--m-xs)",
                  paddingLeft: "var(--m-xxs)",
                  verticalAlign: "middle",
                }}>
                {getIconType(validation.severity)}
              </span>
            </Tooltip>
          </Box>
        )}
      </Box>
    );

    return cellContent;
  }
};